import React, { Suspense } from 'react';
import { useLanguage } from '../LanguageContext';

// Renders a translations.tsx entry. In production this is exactly
// `t(k)`: the NODE_ENV check is a build-time constant, so the minifier
// drops the dev branch and the lazy import below, and none of the editing
// code ships to the live site.
const EditableText = process.env.NODE_ENV === 'development'
  ? React.lazy(() => import('../dev/EditableText'))
  : null;

const T: React.FC<{ k: string }> = ({ k }) => {
  const { t, language } = useLanguage();
  const value = t(k) as unknown as React.ReactNode;
  if (process.env.NODE_ENV !== 'development' || !EditableText) return <>{value}</>;
  return (
    <Suspense fallback={<>{value}</>}>
      <EditableText k={k} lang={language} value={value} />
    </Suspense>
  );
};

export default T;
